import loadAsync from "routing/loadAsync";
const AsyncQueryInput = loadAsync(() => import("./QueryInput"));
export default AsyncQueryInput;
